import { descriptionModalStore } from 'stores/modals/model';
import { Modal } from 'ui-kit/components/Modal';
import { useUnit } from 'effector-react';
import { type FC } from 'types/react';

import { DescriptionWrapper } from './styles';

export const DescriptionModal: FC = () => {
    const { closeModal, modal } = descriptionModalStore;
    const [_, { description }] = useUnit(modal);

    return (
        <Modal onClose={closeModal} width="700px" visible>
            <DescriptionWrapper dangerouslySetInnerHTML={{ __html: description }} />
        </Modal>
    );
};
